import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Ссылка отправлена на почту ")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("или ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Покажите QR код покупателю ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Нет ссылки!")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Ожидание оплаты 15 минут!")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Открыть ссылку... ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode()
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Назад ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card_title, null, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5
      ]),
      _: 1
    }),
    _hoisted_6,
    _createVNode(_component_v_sheet, { class: "d-flex flex-column justify-center align-center" }, {
      default: _withCtx(() => [
        (_ctx.$route.query['url'])
          ? (_openBlock(), _createBlock(_component_v_img, {
              key: 0,
              width: "260",
              src: 'https://api.qrserver.com/v1/create-qr-code/?size=260x260&data='+encodeURIComponent(_ctx.$route.query['url'])
            }, null, 8, ["src"]))
          : (_openBlock(), _createBlock(_component_v_card_title, {
              key: 1,
              class: "text-red-accent-2"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })),
        _hoisted_8,
        _createVNode(_component_v_card_title, { class: "text-red" }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _hoisted_10,
        _createVNode(_component_v_btn, {
          disabled: !_ctx.$route.query['url'],
          color: "primary",
          href: _ctx.$route.query['url']
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["disabled", "href"]),
        _hoisted_12,
        _hoisted_13,
        _hoisted_14,
        _createVNode(_component_v_btn, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }),
        _hoisted_16,
        _hoisted_17
      ]),
      _: 1
    })
  ]))
}